import React from "react"

export const DateIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
            <path id="icons8-date" d="M20,9.111V8.528A2.531,2.531,0,0,0,17.472,6H8.528A2.531,2.531,0,0,0,6,8.528v.583ZM6,10.278v7.194A2.531,2.531,0,0,0,8.528,20h8.944A2.531,2.531,0,0,0,20,17.472V10.278Zm3.694,7.389a.972.972,0,1,1,.972-.972A.972.972,0,0,1,9.694,17.667Zm0-3.5a.972.972,0,1,1,.972-.972A.972.972,0,0,1,9.694,14.167ZM13,17.667a.972.972,0,1,1,.972-.972A.972.972,0,0,1,13,17.667Zm0-3.5a.972.972,0,1,1,.972-.972A.972.972,0,0,1,13,14.167Zm3.306,0a.972.972,0,1,1,.972-.972A.972.972,0,0,1,16.306,14.167Z" transform="translate(-6 -6)" fill="#ced3dd" />
        </svg>

    )
}